import { InitState } from "../constant";
export const getHeaders = ({ appId }) => {
  const { userInfo, tokenInfo } = InitState;

  return {
    'u-platform': 2,
    'u-app-id': appId,
    'u-school': userInfo?.school,
    'u-openid': userInfo?.ssoId,
    Authorization: tokenInfo?.jwt,
  };
};